/* eslint-disable react-hooks/exhaustive-deps */
import { Tabs } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import WebsiteFeaturedProfilesManagementDash from "../../components/WebsiteFeaturedProfilesManagement";
import { WEBSITE_FEATURED_PROFILE_TYPES } from "../../components/WebsiteFeaturedProfilesManagement/helper";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const WebsiteFeaturedProfilesManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  const hasAccess = userConfig?.websiteFeaturedProfiles?.hasAccess;

  useEffect(() => {
    if (!hasAccess) {
      navigate(LOGIN);
    }
  }, []);

  const tabItems = [
    {
      key: WEBSITE_FEATURED_PROFILE_TYPES.MENTOR,
      label: "Mentors",
      children: (
        <WebsiteFeaturedProfilesManagementDash
          profileType={WEBSITE_FEATURED_PROFILE_TYPES.MENTOR}
          userConfig={userConfig}
          ROOT_URL={ROOT_URL}
        />
      )
    },
    {
      key: WEBSITE_FEATURED_PROFILE_TYPES.TESTIMONIAL,
      label: "Testimonials",
      children: (
        <WebsiteFeaturedProfilesManagementDash
          profileType={WEBSITE_FEATURED_PROFILE_TYPES.TESTIMONIAL}
          userConfig={userConfig}
          ROOT_URL={ROOT_URL}
        />
      )
    }
  ];

  return (
    <>
      <Navbar />
      <Tabs
        defaultActiveKey={WEBSITE_FEATURED_PROFILE_TYPES.MENTOR}
        items={tabItems}
        tabBarStyle={{ paddingLeft: 24, paddingRight: 24, marginBottom: 0 }}
      />
    </>
  );
};

export default WebsiteFeaturedProfilesManagement;
